import { usePunditUserContext } from "@circle-react/contexts";

export const useAreAnalyticsFiltersEnabled = () => {
  const { currentCommunity, isLoading } = usePunditUserContext();

  return !!(
    !isLoading && currentCommunity?.analytics_filters_feature_flag_enabled
  );
};
